export default __webpack_public_path__ + "static/media/Button.61feafd8.svg";